// This file is auto-generated by @hey-api/openapi-ts
// @ts-nocheck
import { createClient, createConfig } from './client/index.js';
export const client = createClient(createConfig({ baseUrl: 'https://api.globalping.io' }));
//# sourceMappingURL=client.gen.js.map